import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material';

@Injectable({
	providedIn: 'root',
})
export class MessageService {
	public loading_message = 'Please wait...';
	public oopsMsg = 'Oops, Something went wrong!';
	public deletedSuccessfullyMsg = 'Data deleted successfully!';
	public dataSavedSuccessMsg = 'Data saved successfully!';
	public removeFromPtiMsg = 'You can only remove this entry from PTI!!';
	public loading = false;
	public priorityLoading = false;
	public spinner = false;

	constructor(public snackBar: MatSnackBar) {

	}

	displaySuccessToaster(message) {
		const Toast = (Swal as any).mixin({
			toast: true,
			position: 'top-end',
			showConfirmButton: false,
			timer: 3000,
		});
		Toast.fire({
			icon: 'success',
			title: message,
		});
	}
	displayErrorToaster(message) {
		const Toast = (Swal as any).mixin({
			toast: true,
			position: 'top-end',
			showConfirmButton: false,
			timer: 3000,
		});
		Toast.fire({
			icon: 'error',
			title: message,
		});
	}

	displayWarningToaster(message) {
		const Toast = (Swal as any).mixin({
			toast: true,
			position: 'top-end',
			showConfirmButton: false,
			timer: 3000,
		});
		Toast.fire({
			icon: 'warning',
			title: message,
		});
	}

	displayInfoToaster(message) {
		const Toast = (Swal as any).mixin({
			toast: true,
			position: 'top-end',
			showConfirmButton: false,
			timer: 3000,
		});
		Toast.fire({
			icon: 'info',
			title: message,
		});
	}

	displayInfoToasterWithTime(message, time) {
		const Toast = (Swal as any).mixin({
			toast: true,
			position: 'top-end',
			showConfirmButton: false,
			timer: time,
		});
		Toast.fire({
			icon: 'info',
			title: message,
		});
	}

	displayQuestionMarkToaster(message) {
		const Toast = (Swal as any).mixin({
			toast: true,
			position: 'top-end',
			showConfirmButton: false,
			timer: 3000,
		});
		Toast.fire({
			icon: 'question',
			title: message,
		});
	}

	displaySnackbar(message) {
		this.snackBar.open(message, 'x', { duration: 3000 });
	}

	displaySnackbarpersonalInfo(message) {
		this.snackBar.open(message, 'x', { duration: 5000 });
	}

	displaySnackbardpm(message) {
		this.snackBar.open(message, 'x', { duration: 6000 });
	}

	displayPopup(message) {
		(Swal as any)
			.fire({
				title: 'Are you sure?',
				text: message,
				icon: 'question',
				allowOutsideClick: false,
				keydownListenerCapture: true,
				backdrop: true,
				confirmButtonColor: '#3085d6',
				confirmButtonText: 'Ok',
			}).then(result => {
				
			});
		}
}
